export enum Color {
  Title = '#2B5F75',
  ThemePrimary = '#01579b',
}
